import { GlobalService } from 'src/app/_services/global.service';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/_services/login.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { CreateTalentpoolComponent } from '../talentpool/create-talentpool/create-talentpool.component';
import { CreateCandidateComponent } from './../candidate/create-candidate/create-candidate.component';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { TransactionService } from '../_services/transaction.service';
import { PersonSearchService } from '../_services/person-search.service';
import { DefaultLocationModalComponent } from '../default-location-modal/default-location-modal.component';
import { HireFilterComponent } from '../hire-person-search/hire-filter/hire-filter.component';
import { HiringCriteriaComponent } from '../hire-person-search/hiring-criteria/hiring-criteria.component';
declare const clevertap;

type TourItem = { tour_id?: number, tour_config?: { subtitle?: string, icon?: string, gif_url?: string, allow_skip?: boolean, allow_video?: boolean, yt_video_id?: string }, module?: string, title: string, position?: number, isactive?: boolean };

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {
  successMessage: any;
  errorMessage: string;
  candidateSubject:Subject<any> = new Subject();
  @ViewChild('noCreditTalentpool') noCreditTalentpool: TemplateRef<any>;
  subscriptiondetails: any = {};
  isteamMember: boolean;
  userdata: any
  routeCheckForScrollNavabar:any

  /**
   * Store all tour items
   */
  tourItems: TourItem[] = [];
defaultContinent: string;
  constructor(public modalService: NgbModal,private _localstorageservice : LocalStorageService ,private loginservice : LoginService,
    private router : Router ,private transactionservice:TransactionService, private personSearchService: PersonSearchService, private globalService: GlobalService) { }

  ngOnInit() {
    this.userdata = this._localstorageservice.getItem('userdata')
    this.transactionservice.getPaymentData().subscribe(event => {
      this.userdata = this._localstorageservice.getItem('userdata')
    });

    this.routeCheckForScrollNavabar=  this.router.url.includes('/person/search/listing')

    this.getAllToursData();

    // The credits API (/paymentflow/fetchcurrentplancredits) is only ever called on login
    // (signup.component.ts) and after a reveal-contact action succeeds (CreditActivityService) -
    // no bootstrap fetch here. TransactionService seeds transactionservice.credits() from
    // localStorage on construction, so it's already populated on a plain page refresh too.

    // this.openFilterModal()
    // this.openHiringCriteriaModal()
  }

  /**
   * Fetch all tours data via service
   */
  getAllToursData() {
    this.personSearchService.getPersonSearchTours({}).subscribe((res: any) => {
      if(res && res.status === 'success') {
        this.tourItems = res.data;
           this.defaultContinent = this._localstorageservice.getItem('defaultContinent');
    if(!this.defaultContinent)
       this.openDefaultContinentModal();
      } else {
        console.log("getPersonSearchTours failure res", res);
      }
    }, (err: any) => {
      console.log("getPersonSearchTours failure err", err);
    })
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }


  openCreateCandidate(){
    // const modalRef = this.modalService.open(CreateCandidateComponent, { size: 'lg' as 'lg', backdrop: 'static', keyboard: false ,windowClass: 'custom-class' });
    document.getElementById("mySidebar").style.display = "block";
    document.getElementById("myOverlay").style.display = "block";
    this.candidateSubject.next(undefined as any);

  }

  openCreateTalentpool(){
   // if(this._localstorageservice.getItem('tpcredits') > 0){
    const modalRef = this.modalService.open(CreateTalentpoolComponent, { size: 'lg' as 'lg', backdrop: 'static', keyboard: false ,centered: true,});
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'talentpool-added') {
        this.toastmessage('Talentpool Created Succesfully', 'success')
        this.fetchcredits()
    }
    // else if(x == 'notpcredits'){
    //   const modalRef = this.modalService.open(this.noCreditTalentpool,{ windowClass: "myCustomModalClass", centered: true });
    //   this.sendmailexpiry('Talent Pipeline credits')
    // }
    else if(x =='error'){
      this.toastmessage('Something went wrong, Please try again in a minute', 'error')
    }})
  //}
    // }else{
    //   let clevertap_data = {
    //     "Talent Pool Name" : 'null',
    //   }
    //   this.cleverTapEvent("TalentPool_CreditExpiry", clevertap_data);
    //   const modalRef = this.modalService.open(this.noCreditTalentpool,{ windowClass: "myCustomModalClass", centered: true });
    //   this.sendmailexpiry('Talent Pipeline credits')
    // }
  }

  logout(){
  let userid = this._localstorageservice.getItem('userid')
  let userno = this._localstorageservice.getItem('usernumber')
  let ufname = this._localstorageservice.getItem('ufname')
  let ulname = this._localstorageservice.getItem('ulname')

   let data ={
     email : "'" + this._localstorageservice.getItem('usermailid') + "'"
   }
   this.loginservice.logOut(data).subscribe((res:any)=>{
     if(res.status == 'success'){
      let chromeid = localStorage.getItem('extensionID');
      if(chromeid){
      try {
        window['chrome'].runtime.sendMessage(chromeid, {action: 'logout', usernumber: userno, userid: userid, firstname: ufname, lastname: ulname});
       }
       catch (error) {
        console.error('Here is the error message', error);
       }
      }
      this.router.navigateByUrl('/login')
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem('extensionID', chromeid)
     }
   })

  }

  route2pricing(){
    this.modalService.dismissAll()
    this.router.navigateByUrl('/subscription/usage')
  }

  fetchcredits(){
    // Credits come from the shared signal (populated only on login and after reveal-contact
    // succeeds, see TransactionService) - this no longer calls /paymentflow/fetchcurrentplancredits.
    // Team-admin/team-member branching is already resolved on the signal's payload.
    const creditsData = this.transactionservice.credits();
    if (creditsData) {
      this._localstorageservice.setItem('userPlanData', creditsData);
      this.isteamMember = !!creditsData.teamadmindetails;
      this.subscriptiondetails.balancecontactenrichmentcredits = creditsData.balancecontactenrichmentcredits;
      this.subscriptiondetails.balancejdparsingcredits = creditsData.balancejdparsingcredits;
      this.subscriptiondetails.balancesmartemailcredits = creditsData.balancesmartemailcredits;
      this.subscriptiondetails.balancetalentpipelinecredits = creditsData.balancetalentpipelinecredits;

      this._localstorageservice.setItem('jdcredits', this.subscriptiondetails.balancejdparsingcredits)
      this._localstorageservice.setItem('tpcredits', this.subscriptiondetails.balancetalentpipelinecredits)
      this._localstorageservice.setItem('cecredits', this.subscriptiondetails.balancecontactenrichmentcredits)
      this._localstorageservice.setItem('secredits', this.subscriptiondetails.balancesmartemailcredits);
    }

    // Access comes from the shared signal (populated on login, on navigation into an
    // access-gated route via AccessRefreshGuard, and force-refreshed on continent change) -
    // talentpool creation doesn't change access, so there's no reason to call the API again here.
    const accessData = this.transactionservice.access();
    if (accessData) {
      this._localstorageservice.setItem('hasEUPersonSearchAccess', accessData.haseupersonsearchaccess);
      this._localstorageservice.setItem('hasEUTalentInsightsAccess', accessData.haseutalentinsightsaccess)
      let userPlanData = this._localstorageservice.getItem('userPlanData');
      userPlanData = {...userPlanData, ...accessData}
      this._localstorageservice.setItem('userPlanData', userPlanData);

      const currentRegion = this._localstorageservice.getItem('region');
      if(currentRegion == 'europe' && !accessData.haseupersonsearchaccess) {
        this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
          const region = response.continent ? response.continent.toLowerCase() : 'asia';
          this._localstorageservice.setItem('region', region);
        });
      }

      const currentTIRegion = this._localstorageservice.getItem('talentRegion');
      if(currentTIRegion == 'europe' && !accessData.haseutalentinsightsaccess) {
        this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
          const region = response.continent ? response.continent.toLowerCase() : 'asia';
          this._localstorageservice.setItem('talentRegion', region);
        });
      }
    }
  }

  sendmailexpiry(type){
    let data ={
      expiredmetric : type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }
  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }

  initiatechat() {
    const user = this._localstorageservice.getItem('ufname') + ' ' + this._localstorageservice.getItem('ulname')
    const user_email = this._localstorageservice.getItem('usermailid')
    if(window['fcWidget']) {
      window['fcWidget'].setExternalId(user_email);

      window['fcWidget'].user.setFirstName(user);
      window['fcWidget'].user.setEmail(user_email);
      window['fcWidget'].user.setProperties({
        plan: "Pro",
        status: "Active"
      });

      if(window['fcWidget'].isOpen()) {
        window['fcWidget'].close()
      } else {
        window['fcWidget'].open()
      }
    }

  }

  /**
   * Jump directly to specific item from the tours data list
   * @param itemId page/position to jump to
   */
  goToTour(itemId: number) {
    this.globalService.openTourModal({ pageToJump: (itemId - 1) });
  }

      openDefaultContinentModal() {
          const modalRef = this.modalService.open(DefaultLocationModalComponent, {  windowClass: 'NLSearchMdmodal', centered: true, backdrop: 'static', keyboard: false });
          modalRef.componentInstance.modalDismissEvent.subscribe((res) => {
            if(res === 'success'){
              this.toastmessage('Default continent set successfully', 'success');
            }
        }  )

      }

  /**
   * Helper method to check if extension is installed
   */
  isExtensionInstalled = GlobalService.isExtensionInstalled;


  // new Filter Revamp modal open code
    openFilterModal(){
      console.log('hi')
      this.modalService.open(HireFilterComponent,{windowClass:'hireFiltermodal', centered: true, backdrop: 'static', keyboard: false})
    }
     openHiringCriteriaModal(){
      console.log('hi')
      this.modalService.open(HiringCriteriaComponent,{windowClass:'hireFiltermodal', centered: true, backdrop: 'static', keyboard: false})
    }
}
